<template>
  <div
    v-if="show"
    class="w-full py-2 px-4 text-sm font-semibold flex items-center justify-center gap-4"
    :style="bannerStyle"
  >
    <span>{{ text }}</span>
    <button
      type="button"
      class="flex-shrink-0 font-bold leading-none cursor-pointer text-base"
      aria-label="Dismiss"
      @click="dismissed = true"
    >×</button>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';

import { useGeneralStore } from '@/stores/general';
import { useSettingsStore } from '@/stores/settings';
import { getTextColorForBackground } from '@/utils/getTextColorForBackground';

const BANNER_COLOR = '#FFE100';

const generalStore = useGeneralStore();
const settingsStore = useSettingsStore();
const { pspWarningSettings } = storeToRefs(settingsStore);
const { general } = storeToRefs(generalStore);
const dismissed = ref(false);

const psp = computed(() => general.value?.customer?.psp);

const show = computed(() => {
    console.log("GlobalBanner PSP settings", pspWarningSettings.value, "psp", psp.value);
    
    if (dismissed.value || !pspWarningSettings.value) return false;
    const s = pspWarningSettings.value;
    const p = psp.value;
    return Boolean(
        s.payment_system_warning &&
        ((p === 'quickpay10' && s.show_warning_quickpay) ||
        (p === 'epay' && s.show_warning_epay))
    );
});

const text = computed(() => pspWarningSettings.value?.payment_system_warning ?? '');

const textColor = getTextColorForBackground(BANNER_COLOR);
const bannerStyle = {
    backgroundColor: BANNER_COLOR,
    color: textColor === 'dark' ? 'var(--color-surface-dark)' : 'var(--color-surface-light)',
};
</script>
